import { render, staticRenderFns } from "./KiymetTakdirininYapilmasiTalepEvrakForm.vue?vue&type=template&id=1217e6f8"
import script from "./KiymetTakdirininYapilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./KiymetTakdirininYapilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports